//MJ: Update the buy it now button text with an attribute where the content comes from the customiser, 
//and add a class to make it visible
if ($('body.template-product').length) {

    var textValue = $('.buy__now__button__info').attr('data-buy-now-text');

    setTimeout(function(){
        $('.shopify-payment-button__button--unbranded').html(textValue);
        $('.shopify-payment-button__button--unbranded').addClass('shopify-payment-button__visible');
    }, 3000);

}